module.exports = __webpack_public_path__ + "img/ic_account_cog.dda800d0.svg";